import { ADMINURL } from "helpers/constant";
import { callApi } from "Apis";
import { ROLEURL } from "helpers/constant";

// Admin List Api...
export async function adminListApi(data) {
  try {
    const response = await callApi({ url: ADMINURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Admin Add Api...
export async function addAdminApi(data) {
  try {
    const response = await callApi({ url: ADMINURL.ADD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

//Get Admin By ID...
export async function getAdminDetailById(id) {
  try {
    const response = await callApi({ url: ADMINURL.GET(id), method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}

//Update Admin Api...
export async function updateAdminApi(data) {
  try {
    const response = await callApi({ url: ADMINURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Admin Delete Api...
export async function adminDeleteApi(id) {
  try {
    const response = await callApi({ url: ADMINURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Role List Api...
export async function roleListApi() {
  try {
    const response = await callApi({ url: ROLEURL.ADMIN_ROLE_LIST, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Admin List Api...
export async function allAdminListApi() {
  try {
    const response = await callApi({ url: ADMINURL.ADMIN_GET_ALL_LIST, method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getSubMemberListApi(data) {
  try {
    const response = await callApi({ url: ADMINURL.SUB_MEMBER, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}
